import { postCloseTicket } from "../../../app/api/ServiceRequestDetails";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ISaveServiceRequestResponse } from "../../../Orchestrator/Types/Interface/IServiceRequest";

class CloseServiceRequestAction extends BaseAction<IDefaultActionResult, number> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            const ticketId = this?.params
            if (ticketId) {
                const response = await postCloseTicket(ticketId);
                if (response.answer && response.status === "ok") {
                    const srData: ISaveServiceRequestResponse = response.answer
                    actionResult.data = srData
                    updateRecoilState("activeTicketAtom", srData)
                    updateRecoilState("openActionModalAtom", false);
                    actionResult.status = "success"
                }
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const closeServiceRequestAction = new CloseServiceRequestAction();